import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Vertical).attrs({ gap: 0 })<{ $scrollPercentage: number }>`
  isolation: isolate;
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--c-rgb-black), 0.8);
    opacity: ${({ $scrollPercentage }) => $scrollPercentage};
  }
`;

const PageHeaderTitle = styled(SBHorizontal)`
  width: 100%;
  padding: var(--unit) var(--double-unit);
  &:empty {
    display: none;
  }
`;

export const TransparentMobileWebAppHeader = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPercentage(
        Math.min(
          1,
          Number((window.scrollY / (ref.current?.clientHeight || 1)).toFixed(2))
        )
      );
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <Root ref={ref} $scrollPercentage={scrollPercentage}>
      <PageHeaderTitle id="page-header-title" />
      <div id="page-header-second-row" />
    </Root>
  );
};
